import React from 'react'
import BodyText from 'LuxKit/Typography/BodyText'
import Label from 'LuxKit/Label/Label'
import Caption from 'LuxKit/Typography/Caption'
import SolidFireIcon from 'LuxKit/Icons/solid/SolidFireIcon'

interface Props {
  saleOnDepartures?: boolean
}

export default function TourDiscountLabel(props: Props) {
  const { saleOnDepartures = false } = props
  return (
    <Label kind="plain" variant="urgency" startIcon={<SolidFireIcon />}>
      <Caption variant="medium" weight="bold">
        Limited Time Special{' '}
        {saleOnDepartures && <BodyText variant="small" as="span" colour="neutral-three">(select departures)</BodyText>}
      </Caption>
    </Label>
  )
}
